import { IAPIPerson, Person } from "./person.model"
import { Status } from "./status.model"

export class Profile extends Person {

    constructor(_id?: number, _occupation?: string, _salary?: number, _salaryDay?: number, _remark?: string, _status?: Status[], _dateCreated?: Date, _customerId?: number,
        _customerCode?: string, _reserve?: number, _badDebt?: number, _customerName?: string, _sharedProfileId?: number, _companyId?: number, _companyCode?: string, _icNumber?:string)
    constructor(_id: number, _occupation: string, _salary: number, _salaryDay: number, _remark: string, _status: Status[], _dateCreated: Date, private _customerId: number,
        _customerCode: string, _reserve?: number, _badDebt?: number, private _customerName?: string, private _sharedProfileId?: number, _companyId?: number, 
        _companyCode?: string, _icNumber?: string) 
        { super(_id, _occupation, _salary, _salaryDay, _icNumber, _remark, _status, _dateCreated, _companyId, _customerCode, _companyCode, _reserve, _badDebt) }

    set CustomerID(customerId: number) { this._customerId = customerId }
    get CustomerID(): number { return this._customerId }

    set CustomerName(customerName: string) { this._customerName = customerName }
    get CustomerName(): string { return this._customerName }

    get SharedProfileId(): number {
        return this._sharedProfileId
    }
    set SharedProfileId(value: number) {
        this._sharedProfileId = value
    }
}

export interface IAPIProfile extends IAPIPerson {
    id: number;
    occupation: string;
    salary: number;
    salaryDay: number;
    icNumber: string;
    remark: string;
    status: number[];
    dateCreated: string;
    customerId: number;
    customerCode: string;
    reserve: number;
    badDebt: number;
    customerName: string;
    sharedProfileId: number;
    companyId: number;
    companyCode: string;
}